import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ThemeState {
	mode: 'light' | 'dark';
}

const initialState: ThemeState = {
	mode: (typeof window !== 'undefined' && localStorage.getItem('theme')) as 'light' | 'dark' || 'dark',
};

export const themeSlice = createSlice({
	name: 'theme',
	initialState,
	reducers: {
		setTheme: (state, action: PayloadAction<'light' | 'dark'>) => {
			state.mode = action.payload;
			localStorage.setItem('theme', action.payload);
			document.documentElement.setAttribute('data-theme', action.payload);
		},
		toggleTheme: (state) => {
			state.mode = state.mode === 'light' ? 'dark' : 'light';
			localStorage.setItem('theme', state.mode);
			document.documentElement.setAttribute('data-theme', state.mode);
		},
	},
});

export const { setTheme, toggleTheme } = themeSlice.actions;
export default themeSlice.reducer;
